<template>
    <b-container fluid="true" class="py-3">
        <b-row no-gutters>
            <b-col order="2" order-sm="1" cols="12">
                <b-row no-gutters v-if="getDamPiezometers[1].length > 0">
                        <ChartColumnWrapper
                            v-for="(piezometerItem, index) in piezometersInProfiles"
                            :active-item="piezometerItem"
                            :key="`pzi-${index}`"
                        ></ChartColumnWrapper>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    // mixins
    import chartContainerMixinOnly from "@/mixins/chartContainerMixinOnly";
    // vuex
    import {mapGetters} from "vuex";
    // constants
    import {
        autoStartSensors,
        autoStartTimeFrame,
        iconsUnits,
        sensorsGraphics,
        showPlotLineFor
    } from "../../constants/sensors-constants";
    import {doNotShowTripleData} from "../../constants/chart-constants";
    // components
    import ChartColumnWrapper from "./ChartColumnWrapper";
    import chartSafeTooltipMixin from "@/mixins/chartSafeTooltipMixin";

    /**
     * Container for all piezometers graphics. This is one tab's content.
     * There are 4 in total.
     * Also contains switcher buttons to the right.
     */

    export default {
        name: "ChartPiezometersContainer",
        mixins: [chartSafeTooltipMixin, chartContainerMixinOnly],
        components: {
            ChartColumnWrapper
        },
        data() {
            return {
                sensorsGraphics,
                iconsUnits,
                containsMultiChartItem: false,
                tabTitle: "sensors-page.tab-title-generic"
            }
        },
        computed: {
            // getDamPiezometers returns dict original data and array with sorted keys
            ...mapGetters(['getDamPiezometers', 'getSiteUniqueSensors']),
            /**
             * Need to check the sensor keys from BE as to determine
             * what we exactly have: normal or vw
             */
            realSensorKey() {
                let realKey = 'Piezometer';

                for (let key of this.getSiteUniqueSensors) {
                    if (key.toLowerCase().includes(realKey.toLowerCase())) {
                        realKey = key;
                        break;
                    }
                }

                return realKey;
            },
            /**
             * Generate two profiles as two columns.
             * @return {Object[]}
             */
            piezometersInProfiles() {
                return [
                    this.generatePiezometerItem(1, false),
                    this.generatePiezometerItem(2, false),
                    //this.generatePiezometerItem(1, true),
                    //this.generatePiezometerItem(2, true)
                ];
            }
        },
        methods: {
            /**
             *
             * @param {Number} profile: Left or right profile
             * @param alternative
             * @return {
             * {
             *  showTripleData: boolean, metric: string,
             *  autoStartTimeFrame: number, icon: string,
             *  name: string, alternative: *, title: string,
             *  autoStart: boolean, showPlotLine: boolean,
             *  measuringProfile: Number
             *   }
             *}
             */
            generatePiezometerItem(profile, alternative) {
                return {
                    icon: 'piezometer',
                    name: this.realSensorKey,
                    value: this.getValuesForProfile(profile),
                    metric: 'units.kPa',
                    title: `${this.$i18n.t('sensors-page.piezometers.combined-piezometers')} ${profile}`,
                    alternative: alternative,
                    autoStart: autoStartSensors.includes(this.realSensorKey),
                    autoStartTimeFrame: autoStartTimeFrame,
                    showTripleData: doNotShowTripleData,
                    showPlotLine: showPlotLineFor.includes(this.realSensorKey) && alternative,
                    measuringProfile: profile,
                    containsMultiChartItem: this.containsMultiChartItem
                }
            },
            /**
             * Splits the piezometers into profiles,
             * gets the values and combines them into a string
             * as to show the value, ex. (12, 0.6, 3)
             * @param profile
             * @returns {string}
             */
            getValuesForProfile(profile) {
                let piezometerNames = [...this.getDamPiezometers[1]];
                const half = Math.ceil(this.getDamPiezometers[1].length / 2);

                const firstHalf = piezometerNames.splice(0, half);
                const secondHalf = piezometerNames.splice(-half);

                const valuesArr = [];
                if (profile === 1) {
                     for (const name of firstHalf) {
                         valuesArr.push(this.getDamPiezometers[0][name])
                     }
                } else {
                    for (const name of secondHalf) {
                         valuesArr.push(this.getDamPiezometers[0][name])
                     }
                }

                return valuesArr.join(", ")
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/variables";
    @import "../../assets/scss/mixins";
</style>